const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8010';

interface ApiResponse {
  status: number;
  data: any;
  message?: string;
}

class HospitalApiService {
  private getHeaders(): HeadersInit {
    return { 'Content-Type': 'application/json' };
  }

  // ─── Slug-based Preview ───

  async getPreviewBySlug(slug: string): Promise<ApiResponse> {
    const res = await fetch(`${API_BASE_URL}/api/preview/slug/${encodeURIComponent(slug)}`, {
      headers: this.getHeaders(),
    });
    if (!res.ok) throw new Error('Failed to fetch preview by slug');
    return res.json();
  }

  // ─── Procedure Preview ───

  async getProcPreview(deptId: number, procId: number): Promise<ApiResponse> {
    const res = await fetch(`${API_BASE_URL}/api/departments/${deptId}/procedures/${procId}/preview`, {
      headers: this.getHeaders(),
    });
    if (!res.ok) throw new Error('Failed to fetch procedure preview');
    return res.json();
  }

  async getDeptProcedureVideos(deptId: number, procId: number): Promise<ApiResponse> {
    const res = await fetch(`${API_BASE_URL}/api/departments/${deptId}/procedures/${procId}/videos`, {
      headers: this.getHeaders(),
    });
    if (!res.ok) throw new Error('Failed to fetch videos');
    return res.json();
  }

  // ─── Department Preview ───

  async getDeptPreview(deptId: number): Promise<ApiResponse> {
    const res = await fetch(`${API_BASE_URL}/api/departments/${deptId}/preview`, {
      headers: this.getHeaders(),
    });
    if (!res.ok) throw new Error('Failed to fetch department preview');
    return res.json();
  }

  async getDeptFaqs(deptId: number): Promise<ApiResponse> {
    const res = await fetch(`${API_BASE_URL}/api/departments/${deptId}/faqs`, {
      headers: this.getHeaders(),
    });
    if (!res.ok) throw new Error('Failed to fetch faqs');
    return res.json();
  }

  // ─── Hospital Preview ───

  async getHospitalPreview(): Promise<ApiResponse> {
    const res = await fetch(`${API_BASE_URL}/api/hospital/preview`, {
      headers: this.getHeaders(),
    });
    if (!res.ok) throw new Error('Failed to fetch hospital preview');
    return res.json();
  }
}

const hospitalApiService = new HospitalApiService();
export default hospitalApiService;
